"use client";

import { TopLoadingBar } from "@/components/loading-bar";

type LoadingBarProviderProps = {
  children: React.ReactNode;
};

export function LoadingBarProvider({ children }: LoadingBarProviderProps) {
  return (
    <>
      <TopLoadingBar />
      {children}
    </>
  );
}
